import useSWR from "swr";
import { fetcher } from "../services/config";
import { MethodType } from "src/services/type";

interface EnrollmentStatusResponse {
  editionId: number;
  allEnrollmentsCompleted: boolean;
  totalStudents: number;
  pendingStudents: number;
}

export const useGetEnrollmentStatus = (
  editionId: string | undefined,
  enabled: boolean = true,
) => {
  const url = editionId
    ? `/v3/enrollment/editions/${editionId}/enrollment-status`
    : null;

  const { data, isLoading, error, mutate } = useSWR(
    enabled && url ? [url, MethodType.GET] : null,
    ([url, method]) => {
      return fetcher<EnrollmentStatusResponse>(url, method);
    },
  );

  return {
    enrollmentStatus: data?.data || data,
    isLoading,
    error,
    mutate,
  };
};
